export default {
  'pages.layouts.userLayout.title': 'WebPage',
  'pages.login.accountLogin.tab': 'Cuenta de usuario',
  'pages.login.accountLogin.errorMessage': 'Nombre de usuario/contraseña incorrectos (admin/ant.design)',
  'pages.login.failure': 'Inicio de sesión fallido, ¡por favor inténtalo de nuevo!',
  'pages.login.success': '¡Inicio de sesión exitoso!',
  'pages.login.username.placeholder': 'Correo electrónico',
  'pages.login.username.required': '¡Por favor ingresa tu nombre de usuario!',
  'pages.login.password.placeholder': 'Contraseña',
  'pages.login.password.required': '¡Por favor ingresa tu contraseña!',
  'pages.login.phoneLogin.tab': 'Inicio de sesión con teléfono',
  'pages.login.phoneLogin.errorMessage': 'Error en el código de verificación',
  'pages.login.phoneNumber.placeholder': 'Número de teléfono',
  'pages.login.phoneNumber.required': '¡Por favor ingresa tu número de teléfono!',
  'pages.login.phoneNumber.invalid': '¡El número de teléfono es inválido!',
  'pages.login.captcha.placeholder': 'Código de verificación',
  'pages.login.captcha.required': '¡Por favor ingresa el código de verificación!',
  'pages.login.phoneLogin.getVerificationCode': 'Obtener código',
  'pages.getCaptchaSecondText': 'seg(s)',
  'pages.login.rememberMe': 'Recuérdame',
  'pages.login.forgotPassword': '¿Olvidaste tu contraseña?',
  'pages.login.submit': 'Iniciar sesión',
  'pages.login.loginWith': 'Iniciar sesión con:',
  'pages.login.registerAccount': 'Registrarse',
  'pages.welcome.link': 'Bienvenido',
  'pages.welcome.alertMessage': 'Se han lanzado componentes de alta resistencia más rápidos y potentes.',
  'pages.404.subTitle': 'Lo sentimos, la página que buscas no existe.',
  'pages.404.buttonText': 'Volver a inicio',
  'pages.admin.subPage.title': 'Esta página solo puede ser vista por el administrador',
  'pages.admin.subPage.alertMessage': 'Se ha lanzado Umi ui, usa npm run ui para comenzar la experiencia.',
  'pages.searchTable.createForm.newRule': 'Nueva regla',
  'pages.searchTable.updateForm.ruleConfig': 'Configuración de la regla',
  'pages.searchTable.updateForm.basicConfig': 'Información básica',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nombre de la regla',
  'pages.searchTable.updateForm.ruleName.nameRules': '¡Por favor ingresa el nombre de la regla!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descripción de la regla',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Por favor ingresa al menos cinco caracteres',
  'pages.searchTable.updateForm.ruleDesc.descRules': '¡Por favor ingresa una descripción de la regla con al menos cinco caracteres!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar propiedades',
  'pages.searchTable.updateForm.object': 'Objeto de monitoreo',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Plantilla de la regla',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo de regla',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Establecer período de programación',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora de inicio',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '¡Por favor elige una hora de inicio!',
  'pages.searchTable.titleDesc': 'Descripción',
  'pages.searchTable.ruleName': 'Se requiere el nombre de la regla',
  'pages.searchTable.titleCallNo': 'Número de llamadas al servicio',
  'pages.searchTable.titleStatus': 'Estado',
  'pages.searchTable.nameStatus.default': 'predeterminado',
  'pages.searchTable.nameStatus.running': 'en ejecución',
  'pages.searchTable.nameStatus.online': 'en línea',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Última programación',
  'pages.searchTable.exception': '¡Por favor ingresa el motivo de la excepción!',
  'pages.searchTable.titleOption': 'Opción',
  'pages.searchTable.config': 'Configuración',
  'pages.searchTable.subscribeAlert': 'Suscribirse a alertas',
  'pages.searchTable.title': 'Formulario de consulta',
  'pages.searchTable.new': 'Nuevo',
  'pages.searchTable.chosen': 'seleccionado',
  'pages.searchTable.item': 'ítem',
  'pages.searchTable.totalServiceCalls': 'Número total de llamadas al servicio',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'eliminación en lote',
  'pages.searchTable.batchApproval': 'aprobación en lote',
};
